import { render, staticRenderFns } from "./myAgency.vue?vue&type=template&id=202c2c72&"
import script from "./myAgency.vue?vue&type=script&lang=js&"
export * from "./myAgency.vue?vue&type=script&lang=js&"
import style0 from "./myAgency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports